import { Box, Typography } from "@mui/material";
import IframeCloseButton from "components/wrapper_v2/IframeCloseButton";

const SessionInvalid = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
    >
      <IframeCloseButton />

      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Something went wrong
      </Typography>
      <Typography variant="body1" color="textSecondary">
        Your session has expired or is invalid. Please try again.
      </Typography>
    </Box>
  );
};

export default SessionInvalid;
